import { render, staticRenderFns } from "./Habit.vue?vue&type=template&id=775adf34&"
import script from "./Habit.vue?vue&type=script&lang=js&"
export * from "./Habit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports